var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isScrollTop)?_c('button',{staticClass:"btn-floating btn-lg",attrs:{"id":"btn-back-to-top","title":"Go to top"},on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fas fa-arrow-up c-white"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }